import Modal from "./components/Modal"
import Balance from "./components/Balance"
import WalletConnection from "./components/WalletConnection"
import Game from "./components/Game"
import NavBar from "./components/NavBar"
import Store from "./components/Store"

function App() {

    return (
        <div>
            <NavBar/>
            <div className={"flex h-screen pt-12"}>
                <div className={"mx-auto"}>
                    <div>
                        <Modal/>
                        <WalletConnection>
                            <Game/>
                            <Balance/>
                            <Store/>
                        </WalletConnection>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default App;
